function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "11 15 22 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5a3 3 0 1 0 0 5.999 3 3 0 0 0 0-5.999Zm0 8a5 5 0 1 1 0-10 5 5 0 0 1 0 10ZM22 15a11.826 11.826 0 0 0-11 7.5 11.817 11.817 0 0 0 22 0A11.827 11.827 0 0 0 22 15Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgView;